import React,  { useContext } from 'react'
import { Card, Row, Col, Form, Collapse } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { useState } from 'react';
import ToolBar from '../../../../Common/Toolbar';
import CTextBox from '../../../../Common/CTextBox';
import { ActionButton, css, mergeStyleSets, Toggle, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import { useHistory } from 'react-router-dom';
import { createBoard, saveBoard } from '../../../../../services/sKPI/board.service';
import { enum__KPIAgregationTypes, __Currencies, __enum_SystemPages, __MessageTypes, __Numberfixed, __SystemPagesPaths, __enum_PageMode, __BoardTemplateType, enum__BOARD_TEMPLATE_TYPE, enum__PRIVILEGES } from '../../../../../common/Dictionaries';
import { Dropdown } from '@fluentui/react';
import CLabel from '../../../../Common/CLabel';
import moment from 'moment';
import { isNullOrEmpty, isNullUndefinedOrEmpty, showMessage } from '../../../../../common/Helpers';
import MessageBox from '../../../../Common/Message/MessageBox';
import MainAppContext from '../../../../../MainAppContext';
import PropTypes from 'prop-types';
import BoardAppContext from '../../../../../BoardAppContext';
import { TeachBubble } from '../../../../Templates/TeachBubble';
import { BoardCreacionHelpTexts } from '../../../../../common/HelpPageText';
import { __onGoToBoard, __onGoToProductHome } from '../../../../../common/SystemRedirections';
import { useDispatch, useSelector } from 'react-redux';
import { action_updateBoard, action_updateBoardName, action_updateBoardTemplateType, action_updateBoardTimeAggregation } from '../../../../../reducers/actions/KPI/actions';
import { _checkSecurityUser } from '../../../../../common/Helpers/HLP_Security';
import CValidator from '../../../../Common/CValidator';


function BoardCreationBox(props) {
    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);
    const { _board: objBoard } = useSelector((state) => state.boardScope);

    const BoardTypeId = enum__BOARD_TEMPLATE_TYPE.UNSUPORTED;

    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();

    //Parametros de entrada.
    const { 
        inputParam_EditMode = false,
        inputParam_EnableCollapse = false,
    } = props;

    const [showContent, setShowContent] = useState(false);
    const [txtNameIsInValid, setTxtNameIsInValid] = useState(false);
    const [ddlTypeIsInValid, setDdlTypeIsInValid] = useState(false);
    
    const [tglDisplayCurrencyValue, setTglDisplayCurrencyValue] = useState(false);

    const _priv_canCreateBoard = _checkSecurityUser(contextSite.onlyObserver, contextBoard.userPropsKpi.value, contextSite.securityProps, null, enum__PRIVILEGES.KPI_CONTRACT_CREATE);

    if (_priv_canCreateBoard.value === false && _priv_canCreateBoard.mode === __enum_PageMode.None) {
        window.location.href = "/"
    }

    const [objMessage, setObjMessage] = useState({
        message: null,
        messageType: null,
        showMessage: false,
    });

    const onDisplayCurrencyChange = (e) => {
        setTglDisplayCurrencyValue(true);
    };

    const onTimeAggregationChange = (e, checked) => {
        dispatch(action_updateBoardTimeAggregation(checked ? enum__KPIAgregationTypes.DF_AGG : enum__KPIAgregationTypes.NO_AGG))
    };

    const onBoardTemplateTypeChange = (index, option) => {
        setDdlTypeIsInValid(option.key===-1);
        dispatch(action_updateBoardTemplateType(option.key))
    };

    const onCreateBoard = (e) => {
        let formIsValid = validateForm(objBoard);

        if (formIsValid === true) {

            let itemToSave = {
                id : isNullUndefinedOrEmpty(objBoard.id) ? 0 : objBoard.id,
                boardCode : isNullUndefinedOrEmpty(objBoard.boardCode) ? "" : objBoard.boardCode,
                name : objBoard.name,
                owner : isNullUndefinedOrEmpty(objBoard.owner) ? contextSite.username : objBoard.owner,
                timeAggregationId : isNullUndefinedOrEmpty(objBoard.timeAggregationId) ? enum__KPIAgregationTypes.DF_AGG : objBoard.timeAggregationId,
                displayCurrency : null,
                numberFix : null,
                creationDate : isNullUndefinedOrEmpty(objBoard.creationDate) ? new Date() : objBoard.creationDate,
                boardTypeId: objBoard.boardTypeId
            }

            createBoard(itemToSave).then((response) => {
                if (response.data.succeeded) {
                    dispatch(action_updateBoard({
                        id : response.data.data,
                        boardCode : itemToSave.boardCode,
                        name : itemToSave.name,
                        owner : itemToSave.owner,
                        timeAggregationId : itemToSave.timeAggregationId,
                        displayCurrency : itemToSave.displayCurrency,
                        numberFix : itemToSave.numberFix,
                        creationDate : itemToSave.creationDate,
                        boardTypeId: objBoard.boardTypeId,
                        statusId: 1
                    }))
                    
                    history.push({
                        pathname: `${__SystemPagesPaths[__enum_SystemPages.BoardCreation].text}/${ response.data.data }`
                    })
                }
                else {
                    showMessage(true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        } else {
            showMessage(setObjMessage, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    };

    const onSaveBoard = (e) => {
        let formIsValid = validateForm(objBoard);

        let itemToSave = {
            id : objBoard.id,
            boardCode : objBoard.boardCode,
            name : objBoard.name,
            owner : objBoard.owner === null ? contextSite.username : objBoard.owner,
            timeAggregationId : objBoard.timeAggregationId,
            displayCurrency : null,
            numberFix : null,
            creationDate : objBoard.creationDate === null ? new Date() : objBoard.creationDate,
            statusId: objBoard.statusId
        }

        if (formIsValid === true) {
            saveBoard(itemToSave).then((response) => {
                if (response.data.succeeded) {
                    dispatch(action_updateBoard({
                        id : itemToSave.id,
                        boardCode : itemToSave.boardCode,
                        name : itemToSave.name,
                        owner : itemToSave.owner,
                        timeAggregationId : itemToSave.timeAggregationId,
                        displayCurrency : itemToSave.displayCurrency,
                        numberFix : itemToSave.numberFix,
                        creationDate : itemToSave.creationDate,
                        statusId: itemToSave.statusId
                    }))

                    showMessage(setObjMessage, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setObjMessage, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        } else {
            showMessage(setObjMessage, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    };

    const onCancel = (e) => {
        __onGoToProductHome(__SystemPagesPaths[__enum_SystemPages.HomeKPIV2].text, history, contextSite)
    };

    //Funciones de componente.
    const setterNameValue = (value) => {
        setTxtNameIsInValid(value==="");
        dispatch(action_updateBoardName(value))
    };

    const validateForm = (obj) => {
        const validName = !isNullUndefinedOrEmpty(obj) && !isNullOrEmpty(obj.name);
        const validType = !isNullUndefinedOrEmpty(obj) && !isNullOrEmpty(obj.boardTypeId) && obj.boardTypeId !== -1;

        setTxtNameIsInValid(!validName)
        setDdlTypeIsInValid(!validType)

        return validName;
    };

    const toolBarItems_BookInfo_Edit  = [
        {
            key: 'cancel',
            text: t('data-lang-btn-cancel'),
            iconProps: { iconName: 'NavigateBack' },
            onClick: onCancel,
        },
    ];

    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
    });

    const onCollapseExpandContent = () => {
        setShowContent(!showContent)
    };

    const onLoadBoardTipeDropdown = () => {
        let array = []
        array.push({ key: -1, text: t('data-lang-placeholder-selectoption'), title: t('data-lang-placeholder-selectoption') })
        __BoardTemplateType.map(type => array.push({ key: type.key, text: t(type.text), title: t(type.title) }));

        return array
    };

    const onRenderContent = () => {
        return  <div>
                    <Card.Footer className='row p-0 m-0' style={{borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                        <Col>
                        </Col>
                        <Col className='book-toolbar d-flex col-auto me-auto'>
                            {
                                inputParam_EditMode && (_priv_canCreateBoard.value && _priv_canCreateBoard.mode ===__enum_PageMode.Edit) &&
                                <>
                                    <ActionButton onClick={objBoard === undefined || (objBoard.id === 0 || objBoard.id === undefined) ? onCreateBoard : onSaveBoard} iconProps={{ iconName: 'Save' }} allowDisabledFocus>
                                        { objBoard === undefined || (objBoard.id === 0 || objBoard.id === undefined) ? t('data-lang-btn-create') :  t('data-lang-btn-save') }
                                    </ActionButton>
                                    <ToolBar items={ toolBarItems_BookInfo_Edit } display={ true } />
                                </>
                            }
                        </Col>
                    </Card.Footer>
                    <Card.Body className="card-board p-2 h-1001">
                        <Row>
                            {
                                inputParam_EditMode && (_priv_canCreateBoard.value && _priv_canCreateBoard.mode ===__enum_PageMode.Edit) &&
                                <Col xl={12} className="card-board-body">
                                    <Row>
                                        {
                                            //##Habilitar con posterioridad.
                                            false &&
                                            <Col className='text-end'>
                                                <Toggle
                                                    checked={ tglDisplayCurrencyValue }
                                                    onChange={ onDisplayCurrencyChange }
                                                    role="checkbox"
                                                    onText={ t('data-lang-lbl-nodisplaycurrency') }
                                                    offText={ t('data-lang-lbl-displaycurrency') }
                                                    styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                                />
                                            </Col>
                                        }
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                            <CLabel black={true} labelValue={ !isNullUndefinedOrEmpty(objBoard && objBoard.owner)? objBoard.owner : contextSite.username } labelText={ t('data-lang-lbl-owner') } />
                                        </Col>
                                        <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                            <CLabel black={true} labelValue={ moment(!isNullUndefinedOrEmpty(objBoard && objBoard.creationDate) ? objBoard.creationDate : Date.now()).format("DD/MM/YYYY") } labelText={ t('data-lang-lbl-creationdate') } />
                                        </Col>
                                        <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                            <Toggle
                                                checked={ objBoard !== undefined && objBoard.id !== 0 ? (objBoard.timeAggregationId === enum__KPIAgregationTypes.DF_AGG) : (objBoard === undefined || (objBoard.timeAggregationId === 0 || objBoard.timeAggregationId === null) ? true : (objBoard.timeAggregationId === enum__KPIAgregationTypes.DF_AGG)) }
                                                onChange={ onTimeAggregationChange }
                                                role="checkbox"
                                                onText={ t('data-lang-lbl-defftimeaggregation') }
                                                offText={ t('data-lang-lbl-defftimeaggregation') }
                                                styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                            <CTextBox editMode={ false } controlValue={ objBoard !== undefined ?  objBoard.boardCode : "" } isInValid={null} maxLength={150} textBoxName="code" labelText={ t('data-lang-lbl-code') } />
                                        </Col>
                                        <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                            <CTextBox controlValue={ objBoard !== undefined ? objBoard.name : "" } setterControlValue={ setterNameValue } maxLength={250} isInValid={txtNameIsInValid} textBoxName="name" labelText={ t('data-lang-lbl-name') } />
                                        </Col>
                                        <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                            <Row>
                                                <Col>
                                                    <CLabel black={true} labelText={ t('data-lang-lbl-boardtemplatetype') } />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Dropdown
                                                        disabled={objBoard !== undefined ? objBoard.boardTypeReadOnly === true : false}
                                                        placeholder={t('data-lang-placeholder-selectoption')}
                                                        options={ onLoadBoardTipeDropdown() }
                                                        styles={ {title: { height: "30px" }} }
                                                        selectedKey={objBoard !== undefined ? objBoard.boardTypeId : -1}
                                                        onChange={onBoardTemplateTypeChange}
                                                    />
                                                    <CValidator isInValid={ddlTypeIsInValid} />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    {
                                        //##Habilitar con posterioridad.
                                        false &&
                                        <Row>
                                            <Col className='col' >
                                                <b><Form.Label>{ t('data-lang-lbl-currency') }</Form.Label></b>
                                                <Dropdown
                                                    placeholder={" "}
                                                    styles={ {title: { height: "27px"}} }
                                                    className="pt-1"
                                                    options={__Currencies}
                                                    selectedKey={0}
                                                    onChange={null}
                                                />
                                            </Col>
                                            <Col className='col' xl={4}>
                                                <b><Form.Label>{ t('data-lang-lbl-numberfixed') }</Form.Label></b>
                                                <Dropdown
                                                    placeholder={" "}
                                                    styles={ {title: { height: "27px"}} }
                                                    className="pt-1"
                                                    options={__Numberfixed}
                                                    selectedKey={0}
                                                    onChange={null}
                                                />
                                            </Col>
                                        </Row>
                                    }
                                </Col>
                            }
                            {
                                !inputParam_EditMode || (_priv_canCreateBoard.value && _priv_canCreateBoard.mode ===__enum_PageMode.View) &&
                                <Col xl={12} className="card-board-body">
                                    <Row>
                                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                            <CLabel labelText={ t('data-lang-lbl-owner') } labelValue={ !isNullUndefinedOrEmpty(objBoard)? objBoard.owner : "" } />
                                        </Col>
                                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                            <CLabel labelText={ t('data-lang-lbl-creationdate') } labelValue={ !isNullUndefinedOrEmpty(objBoard)? moment(objBoard.creationDate).format("DD/MM/YYYY") : "" } />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                            <CLabel labelText={ t('data-lang-lbl-name') } labelValue={ !isNullUndefinedOrEmpty(objBoard)? objBoard.name : "" } />
                                        </Col>
                                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                            <CLabel labelText={ t('data-lang-lbl-code') } labelValue={ !isNullUndefinedOrEmpty(objBoard)? objBoard.boardCode : "" } />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                            <CLabel labelText={ t('data-lang-lbl-defftimeaggregation') } labelValue={!isNullUndefinedOrEmpty(objBoard) && objBoard.timeAggregationId === enum__KPIAgregationTypes.DF_AGG ? t('data-lang-btn-yes') : t('data-lang-btn-no') } />
                                        </Col>
                                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                            <CLabel labelText={ t('data-lang-lbl-status') } labelValue={ !isNullUndefinedOrEmpty(objBoard) ? t(`data-lang-skpi-status${objBoard.statusId}`) : "" } />
                                        </Col>
                                    </Row>
                                </Col>                            
                            }
                        </Row>
                    </Card.Body>
                    <Card.Footer>
                        <MessageBox  
                            inputParam_Message={ objMessage.message }
                            inputParam_Display={ objMessage.showMessage }
                            inputParam_MessageType={ objMessage.messageType }
                            inputParam_SetterMessage={ setObjMessage }
                        />
                    </Card.Footer>
                </div>
    }

    return (
        <>
            <Card className='h-100'>
                <Card.Header className={"card-header-compact" + (inputParam_EnableCollapse ? " cursor-pointer" : "")} onClick={inputParam_EnableCollapse ? onCollapseExpandContent : null}>
                    <Card.Title className="d-flex justify-content-between">
                        <b>
                            <TooltipHost
                                overflowMode={TooltipOverflowMode.Self}
                                hostClassName={css(classNames.overflow)}
                                content={ t('data-lang-boxname-boardinformation') }
                                onTooltipToggle={false}
                                styles={{
                                    root: { display: 'block', height: "30px" },
                                }}
                            >
                                {
                                    inputParam_EnableCollapse ?
                                        `${t('data-lang-boxname-boardinformation')} - ${objBoard.name}` :
                                        t('data-lang-boxname-boardinformation')
                                }
                            </TooltipHost>
                        </b>
                        <div className='book-toolbar d-flex'>
                        {
                            inputParam_EnableCollapse &&
                                <ActionButton onClick={onCollapseExpandContent} iconProps={ { iconName: showContent ? 'Blocked2' : 'CirclePlus' } } styles={{root:{height: "30px"}}} display={ true }>
                                    { showContent ? t('data-lang-lbl-collapse') :  t('data-lang-lbl-expand') }
                                </ActionButton>
                        }
                        {
                            !inputParam_EnableCollapse && !isNullUndefinedOrEmpty(objBoard) && objBoard.id !== 0 &&
                                <ActionButton onClick={() => __onGoToBoard(objBoard.id)} iconProps={ { iconName: 'Go' } } styles={{root:{height: "30px"}}} display={ true }>
                                    { t('data-lang-btn-board') }
                                </ActionButton>
                        }
                        {
                            inputParam_EditMode &&
                            <TeachBubble
                                inputParam_ButtonId={ "btnHelpBoardCreation_DefaultTimeAggregation" }
                                inputParam_Text={ t(BoardCreacionHelpTexts.defaultTimeAggregation)}
                                inputParam_Title={ t('data-lang-helptext-title') }
                            />
                        }
                        </div>
                    </Card.Title>
                </Card.Header>
                {
                    inputParam_EnableCollapse &&
                    <Collapse in={showContent} direction="up">
                        {
                            onRenderContent()
                        }
                    </Collapse>
                }
                {
                    !inputParam_EnableCollapse &&
                    <>
                        {
                            onRenderContent()
                        }
                    </>
                }
            </Card>
        </>
    );
}

BoardCreationBox.propTypes = {
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_EnableCollapse: PropTypes.bool.isRequired,
};

export default BoardCreationBox;